import { Day } from '../../core/models/day'
import { Mappable, Mapped } from '../../rest/decorators/mapped'

@Mapped(
  {
    day: { format: Day.create },
    start_at: { property: 'start', type: 'date' },
    finish_at: { property: 'finish', type: 'date' },
  },
  ['timestamps']
)
export class EngineerWorkingDay extends Mappable {
  id!: number
  day!: Day
  start!: Date
  finish!: Date
  created!: Date
  updated!: Date

  static create<Data>(attrs: Data) {
    return new EngineerWorkingDay().map(attrs)
  }
}
